import React from "react";

import {
  AuxiliaryComponent,
  DB_COLLECTION_NAMES,
  PossibleLocations,
} from "@constants";
import {
  DEFAULT_COLLECTIONS_HOOK_RETURN,
  GetCollectionResp,
} from "../firestoreHookTypes";
import {
  CollectionConstraints,
  DEFAULT_COLLECTION_CONSTRAINTS,
  DEFAULT_PAGINATION_OPTS,
  PaginationOpts,
  useGetCollection,
} from "../useGetCollection";

export function useGetAuxiliaryComponents(
  constraints: CollectionConstraints = DEFAULT_COLLECTION_CONSTRAINTS,
  paginationOpts: PaginationOpts = DEFAULT_PAGINATION_OPTS,
): GetCollectionResp<AuxiliaryComponent> {
  const auxComponentsData = useGetCollection<AuxiliaryComponent>(
    DB_COLLECTION_NAMES.AUXILIARY_COMPONENTS,
    constraints,
    paginationOpts,
  );
  if (auxComponentsData.documents) return auxComponentsData;
  return DEFAULT_COLLECTIONS_HOOK_RETURN;
}

export function useGetAuxiliaryComponentsByLocation(
  location: PossibleLocations | "" = "",
) {
  const constraints = React.useMemo<CollectionConstraints>(() => {
    // Only pass comparators to useGetModules if the location is not empty
    if (location) {
      return {
        comparators: [
          {
            fieldOne: "location",
            fieldTwo: location,
            equalityComparator: "==",
          },
        ],
      };
    }
    return [];
  }, [location]);
  return useGetAuxiliaryComponents(constraints);
}
